// First, so its :root block is in the cascade before any stylesheet that
// consumes the tokens - see style/themes.css.
import './style/themes.css';
import './App.css';

import SignIn from './screens/SignIn';
import SignUp from './screens/SignUp';
import ForgotPassword from './screens/ForgotPassword';
import Home from './screens/Home';
import Admin from './screens/Admin';
import Auth from './screens/Auth';
import Meeting from './screens/Meeting';
import { LanguageProvider } from './i18n/LanguageContext';
import { ThemeProvider } from './theme/ThemeContext';
import { router_basename } from './api/Config';

import {
  BrowserRouter as Router,
  Route
} from "react-router-dom";

import { CSSTransition } from 'react-transition-group';

const routes = [
  { path: '/', exact:true, Component: Auth},
  { path: '/home', Component: Home},
  { path: '/admin', Component: Admin},
  { path: '/login', Component: SignIn},
  { path: '/register', Component: SignUp},
  { path: '/forgot-password', Component: ForgotPassword},
  // Standalone and unauthenticated: the whole point of a meeting link is that
  // it works for someone who has no Cyclone account. Meeting renders its own
  // full-screen chrome and never mounts Home's shell or SocketProvider - see
  // screens/Meeting.js.
  { path: '/meet/:code', Component: Meeting},
]

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <Router basename={router_basename}>
              {routes.map(({ path, Component,exact }) => (
                <Route exact={exact} key={path} path={path}>
                  {({ match }) => (
                    <CSSTransition
                      in={match != null}
                      timeout={300}
                      classNames="page"
                      unmountOnExit
                    >
                      <div className="page">
                        <Component />
                      </div>
                    </CSSTransition>
                  )}
                </Route>
              ))}
        </Router>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
